import { render, staticRenderFns } from "./daycall.vue?vue&type=template&id=03889f20&scoped=true&"
import script from "./daycall.vue?vue&type=script&lang=js&"
export * from "./daycall.vue?vue&type=script&lang=js&"
import style0 from "./daycall.vue?vue&type=style&index=0&id=03889f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03889f20",
  null
  
)

export default component.exports